import { Component, OnInit, Type } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DisclaimerPolicyComponent } from './disclaimer-policy/disclaimer-policy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ReturnPolicyComponent } from './return-policy/return-policy.component';
import { TermsComponent } from './terms/terms.component';
import {NotFoundComponent} from "../not-found/not-found.component";

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
})
export class PolicyComponent implements OnInit {
  policyType: string;
  selectedComponent: NotFoundComponent = null; // Store selected component

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.policyType = params['policyType']; // Get policy type from route
      this.loadPolicyComponent();
    });
  }

  loadPolicyComponent(): void {
    // Dynamically set the component based on policyType
    switch (this.policyType) {
      case 'terms':
        this.selectedComponent = TermsComponent;
        break;
      case 'privacy-policy':
        this.selectedComponent = PrivacyPolicyComponent;
        break;
      case 'return-policy':
        this.selectedComponent = ReturnPolicyComponent;
        break;
      case 'disclaimer-policy':
        this.selectedComponent = DisclaimerPolicyComponent;
        break;
      default:
        this.selectedComponent = NotFoundComponent; // Handle unknown policy type
        break;
    }
  }
}
